import { defaultButton, defaultId, defaultStyle, defaultTime } from "./shared.js";
import { buildExaminationSnapshot } from "../shared/chartUtils";

// Custom functions for table columns.
const clickButton = (props, params) => {
    const cmd = "view"; // Could be "edit" or "view"
    props.browser.navigate(`/database/examinations/${params.row.id}/${cmd}`);
};

const createTitle = (props, params) => {
    return "View";
};

const disableButton = (props, params) => {
    return false;
};

const firstName = (props) => ({
    ...defaultStyle,
    field: "patient.first_name",
    headerName: "First name",
    flex: 0.2,
    minWidth: 120,
    valueGetter: (params) => params.row.patient?.first_name ?? "N/A"
});

const lastName = (props) => ({
    ...defaultStyle,
    field: "patient.last_name",
    headerName: "Last name",
    flex: 0.2,
    minWidth: 120,
    valueGetter: (params) => params.row.patient?.last_name ?? "N/A"
});

const examinerUsername = (props) => ({
    ...defaultStyle,
    field: "examiner.username",
    headerName: "Examiner",
    flex: 0.2,
    minWidth: 120,
    valueGetter: (params) => params.row.examiner?.username ?? "N/A"
});

// Column definitions.
const patientRecordNumber = { ...defaultStyle, field: "patient_id", headerName: "Patient record #", flex: 0.15, minWidth: 120 };
const patientIdentifier = {
    ...defaultStyle,
    field: "patient.patient_identifier",
    headerName: "Patient ID",
    flex: 0.15,
    minWidth: 90,
    valueGetter: (params) => params.row.patient?.patient_identifier ?? "N/A"
};
const examinerId = { ...defaultStyle, field: "examiner_id", headerName: "Examiner ID", flex: 0.15, minWidth: 100 };
const notes = { ...defaultStyle, field: "notes", headerName: "Notes", flex: 0.25, minWidth: 200 };
const snapshot = {
    ...defaultStyle,
    field: "snapshot",
    headerName: "Summary",
    flex: 0.4,
    minWidth: 240,
    sortable: false,
    filterable: false,
    valueGetter: (params) => buildExaminationSnapshot(params.row.teeth_data, params.row.summary_data) || "—"
};
const createdAt = { ...defaultTime("created_on"), headerName: "Created on" };
const updatedOn = { ...defaultTime("updated_on"), headerName: "Updated on" };
const action = (props) => {
    return { ...defaultButton(props, { onClick: clickButton, disabled: disableButton, title: createTitle }), minWidth: 100, flex: 0.1 };
};

// Table columns.
export const columns = (props) => [
    defaultId,
    patientRecordNumber,
    patientIdentifier,
    firstName(props),
    lastName(props),
    examinerUsername(props),
    snapshot,
    notes,
    createdAt,
    updatedOn,
    action(props)
];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
